import * as THREE from "three";
import { clamp, LIMITS, type ArmTarget } from "./pose";
import type { Arm } from "./skater-parts";

// Arm helpers shared by the board's pose (`skater-model.ts`) and the rides'
// (`rider/bike-pose.ts`).

/** Bends the elbow by `angle` radians, the forearm swinging in toward the chest (forward only, within its limit). */
export function bendElbow(arm: Arm, angle: number): void {
  arm.elbow.quaternion.setFromAxisAngle(Z_AXIS, -clamp(angle, 0, LIMITS.elbow));
}

/** Poses an arm from its free pose; `side` -1 for the front arm, whose "out" is toward +z. */
export function setArm(arm: Arm, side: -1 | 1, t: ArmTarget): void {
  EULER.set(side * t.out, 0, t.back);
  arm.shoulder.quaternion.setFromEuler(EULER);
  bendElbow(arm, t.bend);
}

/** How far an arm is raised from hanging straight down, radians. */
export function raise(arm: Arm): number {
  return TMP_V.copy(DOWN).applyQuaternion(arm.shoulder.quaternion).angleTo(DOWN);
}

const EULER = new THREE.Euler();
const TMP_V = new THREE.Vector3();
const Z_AXIS = new THREE.Vector3(0, 0, 1);
const DOWN = new THREE.Vector3(0, -1, 0);
